
export const SEVERITY_LABELS: Record<string, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low'
};
